import { motion } from "framer-motion";
import React from "react";
import { twMerge } from "tailwind-merge";

interface AnimateChangeInHeightProps {
  children: React.ReactNode;
  className?: string;
}

export const AnimateChangeInHeight: React.FC<AnimateChangeInHeightProps> = ({
  children,
  className,
  ...props
}) => {
  const [height, setHeight] = React.useState<number | "auto">("auto");
  const resizeObserverRef = React.useRef<ResizeObserver | null>(null);

  const containerRef = React.useCallback((node: HTMLDivElement) => {
    if (node !== null) {
      resizeObserverRef.current = new ResizeObserver((entries) => {
        // We only have one entry, so we can use entries[0].
        const observedHeight = entries?.[0]?.contentRect?.height;
        setHeight(observedHeight ?? "auto");
      });
      resizeObserverRef.current.observe(node);
    } else if (resizeObserverRef.current) {
      // Disconnect the observer when the node is unmounted to prevent memory leaks
      resizeObserverRef.current.disconnect();
    }
  }, []);

  return (
    <motion.div
      style={{ height }}
      animate={{ height }}
      transition={{
        duration: 0.2,
      }}
      className={twMerge("overflow-hidden", className)}
      {...props}
    >
      <div ref={containerRef}>{children}</div>
    </motion.div>
  );
};
